import React, { Component } from "react";
import SideBar from "../components/Presentational/SideBar";
import { connect } from "react-redux";
class SideBarContainer extends Component {
  state = {
    sideMenuItem: [],
    needUpdate: false,
    tosTask: {},
    ClaimCountTask: {},
    orderTask: {},
    listTosTask: {},
  };

  componentDidMount() {
    let sideMenuItem = [
      {
        text: "Home",
        path: "/",
        pageName: "Home",
        icon: "icon-home",
      },
      {
        text: "OS Tracking",
        path: "/tracking",
        pageName: "Os Tracking",
        icon: "icon-plane",
      },
      {
        text: "Order Requirement",
        path: "/order/orderrequirement",
        pageName: "Search Order Requirement",
        icon: "icon-edit",
      },
      {
        text: "TOS",
        pageName: "TosHeader",
        icon: "icon-asl-interpreting",
        subItems: [
          {
            text: "List Order Requirement",
            path: "/tos/listorderrequirement",
            pageName: "List Order Requirement",
          },
          { text: "List Tos", path: "/tos/listTos", pageName: "List Tos" },
        ],
      },
      {
        text: "Shipment Detail",
        path: "/shipmentDetail",
        pageName: "Shipment Detail",
        icon: "icon-ship",
      },
      {
        text: "DTWH",
        path: "/dtwh",
        pageName: "DTWH",
        icon: "icon-calendar",
      },
      {
        text: "Claim",
        pageName: "ClaimHeader",
        icon: "icon-certificate",
        subItems: [
          {
            text: "Claim By CCR",
            path: "/claim/ccr",
            pageName: "Create Claim CCR",
          },
          {
            text: "Claim By TOS",
            path: "/claim/tos",
            pageName: "Create Claim Tos",
          },
          {
            text: "Claim By Manual",
            path: "/claim/manual",
            pageName: "Create Claim Manual",
          },
          {
            text: "Claim Tracking",
            path: "/claim/tracking",
            pageName: "Tracking Claim",
          },
          {
            text: "Attachment",
            path: "/claim/document",
            pageName: "Document Claim",
          },
          {
            text: "Damage Report WH",
            path: "/damageReportSearch",
            pageName: "Damage Report Search",
          },
          {
            text: "Damage Report QA",
            path: "/damageReportQaSearch",
            pageName: "Damage Report QA Search",
          },
        ],
      },
      {
        text: "Forex",
        path: "/forex",
        pageName: "Forex",
        icon: "icon-bank",
      },
      {
        text: "Master",
        icon: "icon-gear",
        subItems: [
          {
            text: "Master Price",
            path: "/masterprice",
            pageName: "Master Price",
          },
          {
            text: "Master Supplier",
            path: "/mastersupplier",
            pageName: "Master Suplier",
          },
          {
            text: "Safety Stock",
            path: "/mastersafetystock",
            pageName: "Master Safety Stock",
          },
          { text: "Master TP", path: "/masterTP", pageName: "MasterTP" },
          {
            text: "Master Claim Problem",
            path: "/masterClaimProblem",
            pageName: "MasterClaimProblem",
          },
          { text: "Master NCR", path: "/masterNCR", pageName: "MasterNCR" },
          {
            text: "Master Inland",
            path: "/masterInlandCost",
            pageName: "Master Inland Cost",
          },
          {
            text: "Master Material PO Text",
            path: "/masterMaterialPoText",
            pageName: "Master Material Po Text",
          },
          {
            text: "Master Product Document",
            path: "/MasterProductDocument",
            pageName: "Master Product Document",
          },
          {
            text: "Master Destination Port",
            path: "/MasterDestinationPort",
            pageName: "Master Destination Port",
          },
          {
            text: "Master Grade Food",
            path: "/MasterGradeType",
            pageName: "Master Grade Type",
          },
          {
            text: "Master Inland Trans",
            path: "/MasterInlandTrans",
            pageName: "Master Inland Trans",
          },
          {
            text: "Master Config",
            path: "/MasterConfig",
            pageName: "Master Config",
          },
          {
            text: "Master TOS Workflow",
            path: "/MasterTosWorkflow",
            pageName: "Master TOS Workflow",
          },
          // { text: 'Master Org Config', path: '/MasterOrgConfig', pageName: 'Master Organization Config' }
        ],
      },
      {
        text: "Interface SAP",
        icon: "icon-cogs",
        subItems: [
          {
            text: "Sap PO",
            path: "/sappo",
            pageName: "Sap PO",
            icon: "icon-tag",
          },
          {
            text: "Manual PO",
            path: "/manualpo",
            pageName: "Manual PO",
            icon: "icon-tags",
          },
          {
            text: "No GR",
            path: "/ShipmentGr",
            pageName: "Shipment Gr",
            icon: "icon-tags",
          },
        ],
      },
      {
        text: "User Manager",
        icon: "icon-user",
        subItems: [
          {
            text: "Manage Account",
            path: "/account",
            pageName: "Manage Account",
          },
          { text: "Manage Role", path: "/role", pageName: "Manage Role" },
        ],
      },
    ];

    this.setState({
      sideMenuItem,
    });
  }

  static getDerivedStateFromProps(nextProp, prevState) {
    if (nextProp.layout.ClaimCountTask !== prevState.ClaimCountTask) {
      return {
        needUpdate: true,
        ClaimCountTask: nextProp.layout.ClaimCountTask,
      };
    } else if (nextProp.layout.orderTask !== prevState.orderTask) {
      return {
        orderTask: nextProp.layout.orderTask,
        needUpdate: true,
      };
    } else if (nextProp.layout.tosTask !== prevState.tosTask) {
      return {
        tosTask: nextProp.layout.tosTask,
        needUpdate: true,
      };
    } else if (nextProp.layout.listTosTask !== prevState.listTosTask) {
      return {
        listTosTask: nextProp.layout.listTosTask,
        needUpdate: true,
      };
    }
    return null;
  }

  componentDidUpdate() {
    if (this.state.needUpdate) {
      this.setState({
        needUpdate: false,
        sideMenuItem: this.state.sideMenuItem.map((m) => {
          if (m.pageName === "ClaimHeader")
            return {
              ...m,
              text: (
                <span>
                  Claim&nbsp;
                  {this.state.ClaimCountTask.WF !== null ? (
                    <span
                      title="Waiting for affirment"
                      onClick={(e) => (window.location = "/claim/tracking/wfa")}
                      className="label label-warning"
                    >
                      {this.state.ClaimCountTask.WF || 0}
                    </span>
                  ) : null}
                  {this.state.ClaimCountTask.WD !== null ? (
                    <span
                      title="Waiting for deduct"
                      onClick={(e) => (window.location = "/claim/tracking/wfd")}
                      className="label label-info"
                    >
                      {this.state.ClaimCountTask.WD || 0}
                    </span>
                  ) : null}
                </span>
              ),
              subItems: m.subItems.map((n, ii) => {
                if (n.pageName === "Damage Report QA Search")
                  return {
                    ...n,
                    text: (
                      <span>
                        Damage Report QA
                        {this.state.ClaimCountTask.DamageReportQa !== null ||
                        this.state.ClaimCountTask.DamageReportQaApprove !==
                          null ? (
                          <br />
                        ) : null}
                        {this.state.ClaimCountTask.DamageReportQa !== null ? (
                          <span
                            title=" Waiting for Approve"
                            onClick={(e) =>
                              (window.location =
                                "/damageReportQaSearch?whOnly=1")
                            }
                            className="label label-success"
                          >
                            {this.state.ClaimCountTask.DamageReportQa || 0}
                          </span>
                        ) : null}
                        {this.state.ClaimCountTask.DamageReportQaApprove !==
                        null ? (
                          <span
                            title=" Approved"
                            onClick={(e) =>
                              (window.location =
                                "/damageReportQaSearch?qaApprove=1")
                            }
                            className="label label-info"
                          >
                            {this.state.ClaimCountTask.DamageReportQaApprove ||
                              0}
                          </span>
                        ) : null}
                      </span>
                    ),
                  };
                else if (n.pageName === "Create Claim Tos")
                  return {
                    ...n,
                    text: (
                      <span>
                        Claim By TOS &nbsp;
                        {this.state.ClaimCountTask.DamageReportWh !== null ? (
                          <span
                            title="Over 500 KG"
                            onClick={(e) =>
                              (window.location =
                                "/damageReportQaSearch?over500Kg=1")
                            }
                            className="label label-success"
                          >
                            {this.state.ClaimCountTask.DamageReportWh || 0}
                          </span>
                        ) : null}
                      </span>
                    ),
                  };
                else return n;
              }),
            };
          else if (m.pageName === "Search Order Requirement") {
            return {
              ...m,
              text: (
                <span>
                  Order Requirement&nbsp;
                  <span
                    title="Wait for Approve"
                    onClick={(e) =>
                      (window.location = "/order/orderrequirement/wfa")
                    }
                    className="label label-info"
                  >
                    {this.state.orderTask.WaitForApprove || 0}
                  </span>
                  <br />
                  <span
                    title="Rejected"
                    onClick={(e) =>
                      (window.location = "/order/orderrequirement/rej")
                    }
                    className="label label-danger"
                  >
                    {this.state.orderTask.Rejected || 0}
                  </span>
                  <span
                    title="Waiting you for Approve"
                    onClick={(e) =>
                      (window.location = "/order/orderrequirement/wa")
                    }
                    className="label label-primary"
                  >
                    {this.state.orderTask.WaitForSMApprove || 0}
                  </span>
                  <span
                    title="You had Rejected"
                    onClick={(e) =>
                      (window.location = "/order/orderrequirement/smrej")
                    }
                    className="label label-warning"
                  >
                    {this.state.orderTask.SmRejected || 0}
                  </span>
                </span>
              ),
            };
          } else if (m.pageName === "TosHeader")
            return {
              ...m,
              text: (
                <span>
                  TOS&nbsp;
                  {this.state.tosTask.WaitingForSelect !== null ? (
                    <span
                      title="Waiting for Select"
                      onClick={(e) =>
                        (window.location = "/tos/listorderrequirement/wfs")
                      }
                      className="label label-success"
                    >
                      {this.state.tosTask.WaitingForSelect || 0}
                    </span>
                  ) : null}
                  {this.state.tosTask.WaitingForApprove !== null ? (
                    <span
                      title="Waiting for Approve"
                      onClick={(e) =>
                        (window.location = "/tos/listorderrequirement/wfa")
                      }
                      className="label label-info"
                    >
                      {this.state.tosTask.WaitingForApprove || 0}
                    </span>
                  ) : null}
                  {this.state.tosTask.Rejected !== null ? (
                    <span
                      title="Reject"
                      onClick={(e) =>
                        (window.location = "/tos/listorderrequirement/rej")
                      }
                      className="label label-danger"
                    >
                      {this.state.tosTask.Rejected || 0}
                    </span>
                  ) : null}
                  {this.state.tosTask.WaitingYouForApprove !== null ? (
                    <span
                      title="Waiting you approve!"
                      onClick={(e) =>
                        (window.location = "/tos/listorderrequirement/wya")
                      }
                      className="label label-warning"
                    >
                      {this.state.tosTask.WaitingYouForApprove || 0}
                    </span>
                  ) : null}
                </span>
              ),
              subItems: m.subItems.map((n) => {
                if (n.pageName === "List Tos")
                  return {
                    ...n,
                    text: (
                      <span>
                        List Tos&nbsp;
                        {this.state.listTosTask.WR !== null ? (
                          <span
                            title="Wait for release"
                            onClick={(e) =>
                              (window.location = "/tos/listTos/wr")
                            }
                            className="label label-success"
                          >
                            {this.state.listTosTask.WR}
                          </span>
                        ) : null}
                        {this.state.listTosTask.Release !== null ? (
                          <span
                            title="Released Po"
                            onClick={(e) =>
                              (window.location = "/tos/listTos/r")
                            }
                            className="label label-info"
                          >
                            {this.state.listTosTask.Release}
                          </span>
                        ) : null}
                      </span>
                    ),
                  };
                return n;
              }),
            };
          else return m;
        }),
      });
    }
  }

  render() {
    return <SideBar {...this.props.layout} {...this.state} />;
  }
}

export default connect((state) => ({
  layout: state.layout,
}))(SideBarContainer);
